const api = {
    SubmitFile: "/SubmitOrder/SubmitFile",
    GetOrderInfo:"/SubmitOrder/GetOrderInfo",
    test:"/test",
    DeleteOrderInfo:"/SubmitOrder/DeleteOrderInfo",
    GetResultFile:"/SubmitOrder/GetResultFile"

    
}
export default api; 